module.exports = __webpack_public_path__ + "img/star1green.ac7332f1.png";